import {Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { TabitOrderProcessService } from 'src/app/tabit-order/tabit-order-process.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { ExpayService } from 'src/app/_services/expay.service';
import { appEnums } from 'src/app/_core/static/us-states';
import {GiftcardDialogComponent} from 'src/app/dialogs/giftcard-dialog/giftcard-dialog.component';

import * as _ from 'lodash';
import {MatSidenav} from "@angular/material/sidenav";
declare const $: any;

@Component({
    selector: 'app-tabit-order-pay',
    templateUrl: './tabit-order-pay.component.html',
    styleUrl: './tabit-order-pay.component.scss',
    standalone: false
})
export class TabitOrderPayComponent implements OnInit, AfterViewInit {
	@ViewChild('paymentForm', { static: false }) public paymentForm: NgForm;
	@Input() public data;
	@Output() onPayment = new EventEmitter<any>();
	@Output() onOrderDone = new EventEmitter<any>();
	$storage;

	public phoneForm;
	public contactForm;
	contacMode: boolean = false;

	maxCreditPayment: number = 0;
	wasMaxCreditPaymentActive: boolean = false;

	showPaymentTypes: boolean = true;
	usStates = appEnums.usStates;
	stateFormControl = new UntypedFormControl('', Validators.required);

	ui: any = {};
	ccinfo: any;
	missingPM: boolean = false;
	wallet: any;
	walletPm: any;
	enableSaveToWallet: boolean = false;
	gratuityAmount;
	step: any = 'alternatePayment';

	constructor(
		public dialog: MatDialog,
		public appService: AppService,
		public orderService: OrderService,
		public dialogsService: DialogsService,
		public generalUtils: GeneralUtilsService,
		public expayService: ExpayService,
		public orderProcess: TabitOrderProcessService,
	) {
		this.$storage = this.orderService.$storage;
		this.ccinfo = { type: undefined }
		this.calculateCCinfoAmount();

		if (!this.appService.user && (!localStorage.getItem("c_phone") || !localStorage.getItem("c_name"))) {
			this.contacMode = true;
			this.contactForm = new UntypedFormGroup({
				phone: new UntypedFormControl('', [Validators.required]),
				name: new UntypedFormControl('', [Validators.required]),
			});

		} else {
			this.init();
		}
	}

	applyContact() {
		if (!this.contactForm.valid) {
			this.contactForm.get("phone").markAsTouched({ onlySelf: true });
			this.contactForm.get("name").markAsTouched({ onlySelf: true });
		} else {
			const phone = this.contactForm.value.phone;
			if (!this.appService.isValidMobilePhone(phone)) return;
			localStorage.setItem('c_phone', phone);

			const name = this.contactForm.value.name;
			localStorage.setItem('c_name', name);
			this.contacMode = false;
			this.init();
		}
	}

	init() {
		let that = this;

		this.phoneForm = new UntypedFormGroup({
			phone: new UntypedFormControl('', [Validators.required]),
		});

		if (!this.$storage.contact?.firstName && localStorage.getItem("c_name")) {
			this.$storage.contact.firstName = localStorage.getItem("c_name");
		}
		if (localStorage.getItem("c_phone")) this.phoneForm.setValue({ phone: localStorage.getItem("c_phone") });
		if (this.appService.region == 'IL') this.maxCreditPayment = 1500;

		this.gratuityAmount = this.$storage.gratuity?.amount;

		// ----------------------------------------------------------------------->
		// prepare payments methods
		// ----------------------------------------------------------------------->

		var arr = [], arrEx = [];
		const storage = this.$storage;
		const order = storage.order;
		const disableGratuityCash = !storage.disableCashPayment && storage.enableGratuity && order.gratuityAmount && order.gratuityAmount != 0;
		const disableCash = storage.disableCashPayment || disableGratuityCash;
		const disableCredit = that.$storage.order.grandTotalPlusTip > 1000;

		_.each(storage.paymentAccounts, (pm) => {
			let sch = pm.schedule = null;
			if (!sch || storage.activeTimeslots[sch] !== false) {

				if (pm.paymentType != "cash" || !disableCash) {

					if (pm.paymentType == "CreditGuard" && this.expayService.showNativePaymentButtons(this.$storage) && this.$storage.rosConfig?.config?.settings?.tabitPayNativePaymentsOnly) {
						return;
					}
					if (pm.isExternal) pm.paymentType = 'external';
					arr.push(pm);
					if (pm.paymentType == "cash") that.ui.cashMethod = pm;
				}
			};
		});

		const bitIndex = _.findIndex(arr, { paymentType: "Meshulam" });
		if (bitIndex != -1) {
			const bitPM = arr[bitIndex];
			arr.splice(bitIndex, 1);
			arr.unshift(bitPM);
		}

		this.ui.paymentMethods = arr;
		//if (this.appService.region == 'US') this.ui.paymentMethods = arr.concat(arrEx);
		//this.ui.exPaymentMethods = arrEx;

		const n = this.ui.paymentMethods.length;
		if (n) {
			if (n == 1 && this.ui.paymentMethods[0].paymentType == 'Braintree') {
				this.showPaymentTypes = false;
			}
			const selectedPm = this.ui.paymentMethods[0];
			if (this.appService.region != 'IL' || !disableCredit || selectedPm.paymentType != 'creditCard') {
				//this.setPaymentMethod(this.ccinfo, this.ui.paymentMethods[0], true);
			}
		}

		// ------------------------------------------------------------------------------------------------->
		// wallet
		// ------------------------------------------------------------------------------------------------->

		const userWallet = _.get(this.$storage, 'wallet');
		if (userWallet) {
			this.step = 'general';
			const wallet = this.$storage.wallet;
			if (!wallet.defaultCCinfo) {
				wallet.defaultCCinfo = wallet.ccinfo;
			} else {
				wallet.ccinfo = wallet.defaultCCinfo;
			}
			const _ccinfo = wallet.ccinfo;
			if (!this.checkWalletPaymentByAccount(wallet.ccinfo, true)) {
				delete wallet.ccinfo;
				for (var i = 0; i < wallet.pms.length; i++) {
					let _pm = wallet.pms[i];
					if (_pm == _ccinfo) continue;
					if (this.checkWalletPaymentByAccount(_pm, true)) {
						wallet.ccinfo = _pm;
						break;
					}
				}
				if (!wallet.ccinfo) {
					this.step = 'alternatePayment';
				}
			}
			if (wallet.ccinfo) this.walletPm = wallet.ccinfo;
		}

		if (['IL'].includes(this.appService.region)) {
			setTimeout(() => {
				// We need to pass the class name in order to preserve the generic ability to append
				// the buttons for Tabit Pay and GCS also
				this.appendApplePayButton('.apple-pay-button-wrapper');
				this.expayService.appendGooglePayButton('.google-pay-button-wrapper');
			}, 250);
		}
	}

	ngAfterViewInit() {
		let amount = this.ccinfo.amount;
		if (!amount) {
			this.submit(this.paymentForm)
		} else if (this.step == 'alternatePayment' && this.ui.paymentMethods.length == 1 && !this.expayService.showNativePaymentButtons(this.$storage)) {
			this.setPaymentMethod(this.ccinfo, this.ui.paymentMethods[0]);
			this.submit(this.paymentForm)
		}
	}

	ngOnInit(ev?) { }

	// ------------------------------------------------------------------------------------------------->
	// giftCard
	// ------------------------------------------------------------------------------------------------->

	openGiftcardDialog(pm?, giftCard?) {
		const gratuityAmount = _.get(this.$storage, 'gratuity.amount', 0);
		let dialogRef = this.dialog.open(GiftcardDialogComponent, {
			backdropClass: 'dialog-backdrop-dark',
			panelClass: 'rounded-dialog',
			direction: this.appService.direction,
			disableClose: true,
			autoFocus: false,
			width: '90vw',
			data: { maxAmount: this.ccinfo.amount - gratuityAmount, account: pm, giftCard }
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result != undefined) {
				this.calculateCCinfoAmount();
				if (this.ccinfo.amount === 0) {
					this.submitContinue();
				}
			}
		});
	}

	removeGiftcard(patment) {
		this.appService.confirm({content:'are_you_sure'}).then(response => {
			let target = this.$storage.giftCards?.cards;
			let index = target.indexOf(patment);
			target.splice(index, 1);
			this.orderService.calculateBasketTotal();
			this.calculateCCinfoAmount();
			this.orderService.cacheOrder();
		});
	}

	calculateCCinfoAmount() {
		this.ccinfo.amount = this.$storage.order.grandTotal - this.$storage.order.giftCardsTotal;
		if (this.ccinfo.amount < 0 && this.$storage.giftCards?.cards) {
			this.$storage.giftCards.cards = [];
			this.orderService.calculateBasketTotal();
			this.calculateCCinfoAmount();
		}
	}

	// ------------------------------------------------------------------------------------------------->
	// payments
	// ------------------------------------------------------------------------------------------------->

	setWalletPayment(pm) {
		if (!this.checkWalletPaymentByAccount(pm)) return;
		this.$storage.wallet.ccinfo = this.walletPm = pm;
		this.ccinfo =  { type: undefined };
		this.calculateCCinfoAmount();
		this.step = 'general';
	}

	setPaymentMethod(ccinfo, pm, silent?) {
		if (!this.checkPaymentClick('pm', pm, ccinfo, silent)) return;

		if (pm.paymentType == 'giftCard') {
			return this.openGiftcardDialog(pm);
		}

		delete this.$storage.wallet?.ccinfo;
		this.step = 'alternatePayment';

		this.missingPM = false;
		ccinfo.caption = pm.name;
		ccinfo.paymentMethod = pm.paymentType;
		ccinfo.account = pm._id;
		ccinfo.requireIdPhoneTrans = pm.requireIdPhoneTrans;
		ccinfo.merchantNumber = pm.merchantNumber;
		ccinfo.$$isExternal = pm.isExternal;
		ccinfo.paymentVerificationStrategy = _.get(pm, 'paymentVerificationStrategy', 'none');
		ccinfo.fullAddressRequired = pm.fullAddressRequired;
		ccinfo.zipCodeRequired = pm.zipCodeRequired;

		if ((["creditCard", "Cibus", "10bis"]).indexOf(pm.paymentType) == -1) {
			if (pm.paymentType == 'giftCard') this.checkGiftCardAccount(ccinfo);
			this.enableSaveToWallet = false;
			this.ui.updatePaymentInfo = false;
		} else {
			this.enableSaveToWallet = true;
		}
		// Apple/Google Pay logic
		if ((["creditGuard", "CreditGuard"]).includes(pm.paymentType) && pm.providerInfo) {
			ccinfo.providerInfo = pm.providerInfo;
		}
	}

	checkGiftCardAccount(ccinfo) {
		let _acc: any = _.find(this.ui.paymentMethods, { paymentType: "giftCard" });
		if (!_acc) return;
		let pm: any = _.find(_acc.accounts, { _id: ccinfo.account });
		if (pm) ccinfo.loyaltyApiKey = pm.loyaltyApiKey
	}

	checkWalletPaymentByAccount(pm, silent?) {
		let account = _.find(this.ui.paymentMethods, { _id: pm.account });
		return this.checkPayment(account, silent)
	}

	checkPayment(account, silent?) {
		if (!this.gratuityAmount || account.enableGratuity) return true;
		if (!silent) {
			let message = this.appService.translate("MESSAGES.GRATUITY_NOT_ALLOWED_FOR_PM", { pm: account.name });
			this.appService.alert({ content: message, "confirmText": "GOT_IT" }).then(res => { }).catch(err => { });
		}
		return false;
	}

	checkPaymentClick(source, account, ccinfo?, silent?) {
		if (!this.gratuityAmount || account.enableGratuity) return true;
		if (silent) return false;

		let message = this.appService.translate("MESSAGES.GRATUITY_NOT_ALLOWED_FOR_PM", { pm: account.name });
		this.appService.confirm({
			content: message,
			confirmText: 'SELECT_ALTERNATE_PYMENT',
			cancelText: 'CONTINUE_WITHOUT_GRATUITY',
		}).then(res => {

		}).catch(err => {
			this.orderService.clearOrderGratuity()
			this.gratuityAmount = 0;
			if (source == 'pm') this.setPaymentMethod(ccinfo, account);
		});

		return false;
	}

	// ------------------------------------------------------------------------------------------------->
	// apply
	// ------------------------------------------------------------------------------------------------->

	manualSubmit(from?) {
		//this.paymentForm.onSubmit(undefined);
		this.submitContinue(from);
	}

	submit(form, ev?) {

		if (!this.ccinfo.amount) {
			this.submitContinue();
			return;
		}

		if (!this.appService.user && this.ccinfo.paymentMethod != 'Meshulam') {
			if (!this.phoneForm.valid) {
				this.phoneForm.get("phone").markAsTouched({ onlySelf: true });
				return;
			} else {
				const phone = this.phoneForm.value.phone;
				if (!this.appService.isValidMobilePhone(phone)) return;
				localStorage.setItem('c_phone', phone);
				this.$storage.contact.phone = phone;
			}
		}
		if (this.step == 'alternatePayment' && !this.ccinfo.paymentMethod) {
			this.missingPM = true;
			return;
		}
		if (!form.valid || (_.get(this.ccinfo, 'paymentVerificationStrategy') == 'fullAddress' && !this.ccinfo.state && !['Stripe', 'AuthorizeNet'].includes(this.ccinfo.paymentMethod))) return;
		if (!this.appService.user && !this.$storage.contact.contractApprove) {
			this.appService.confirm({
				content: 'MESSAGES.DO_YOU_APPROVE_CONTRACT',
				confirmText: 'yes',
				cancelText: 'no',
				enlargeTextButtons: true
			}).then(res => {
				this.$storage.contact.contractApprove = true;
				this.submitContinue();
			}).catch(err => { });
		} else {
			this.submitContinue();
		}
	}

	async submitContinue(from?) {
		delete window['LAST_PAYMENT_AMOUNT'];
		let args: any = { gratuityAmount: this.$storage.gratuity?.amount };

		this.$storage.order.$ccinfo = null;

		this.appService.cachedPaymentInfo = null;
		this.appService.cacheContact = this.$storage.contact;

		if (this.step == 'alternatePayment') {
			this.appService.trackData('payment click', { from: from, loggedIn: this.appService.user != null, wallet: false });

			if (!this.appService.user && this.$storage.contact.firstName) {
				this.$storage.contact.name = this.$storage.contact.firstName;
				localStorage.setItem('c_name', this.$storage.contact.name);
			} else if (from) {
				this.$storage.contact.name = from;
			}

			if (this.ccinfo.amount) {
				args.ccinfo = this.ccinfo;
				args.alternatePayment = true;
				if (this.ccinfo.paymentMethod == 'Braintree') {
					try {
						let braintreeRes = await this.expayService.initBraintree(this.$storage.customPaymentAccount, this.ccinfo.amount);
						if (!braintreeRes) throw ({});
						args.ccinfo.nonce = braintreeRes["nonce"];
						args.ccinfo.deviceData = braintreeRes["deviceData"];
					} catch (err) {
						return;
					}
				} else {
					if (this.enableSaveToWallet) {
						this.appService.cachedPaymentInfo = this.generalUtils.ccInfoToWalletPayment(this.ccinfo);
						this.$storage.order.$ccinfo = this.ccinfo;
						if (this.ui.updatePaymentInfo) { args.updatePaymentInfo = true; };
					}
				}
			}
		} else {
			this.appService.trackData('payment click', { from: 'wallet', loggedIn: this.appService.user != null, wallet: true });
			if (this.ccinfo.amount) {
				const ccinfo = _.cloneDeep(this.$storage.wallet.ccinfo);
				await this.generalUtils.checkForIdCard(ccinfo);

				const ccdetails = _.get(this, 'ccinfo.customerDetails');
				if (ccdetails) ccinfo.customerDetails = ccdetails;
				if (ccinfo.walletPayment && ['creditCard', 'CreditGuard', 'creditGuard'].includes(ccinfo.paymentType)) {
					// For wallet payment the account is selected as the wallet payment id
					ccinfo.walletPaymentMethodId = ccinfo.walletPayment;
					ccinfo.paymentType = 'CreditGuard';
				}
				if (!ccinfo.amount) ccinfo.amount = this.ccinfo.amount;
				args.ccinfo = ccinfo;
			}
		}

		this.appService.startBlock({ text: "PERFORMING_PAYMENT", class: 'dark-block' });
		try {
			this.orderService.stopActivityTimer();
			let processResponse = await this.orderProcess.processPayment(this.$storage, args);
			this.appService.stopBlock({ class: 'dark-block' });
			this.$storage.wasPayment = true;
			this.$storage.resultOrder = processResponse;
			//if (this.$storage.order?.taxAndFees) {
				const responseTotals = processResponse.totals;
				_.set(this.$storage, 'order.taxAndFees.fees',(responseTotals.totalFees || 0) / 100);
				this.$storage.order.realGrandTotal = responseTotals.totalAmount / 100;
			//}
			this.orderService.cacheBasket();
			this.onOrderDone.emit({});
		} catch (err) {
			this.orderService.startActivityTimer();
			this.showPaymentTypes = true;
			this.appService.stopBlock({ class: 'dark-block' });
			if (err.type == 'CANCELED') return;

			const errorCode = err.error?.code || err.code;
			switch (errorCode) { //already handoff
				case 409136:
					this.onOrderDone.emit({});
					return;
			}
			if (err.phone) {
				this.generalUtils.showMessageWithPhone(err.message, err.phone);
			} else {
				if (errorCode && !err.wasErrorDesc) {
					let _message = this.orderService.getOrderError(err.error);
					if (_message) err.message = _message;
				}
				this.appService.alert({ content: err.message }).then(() => {
					if (errorCode == 20106) {
						this.onOrderDone.emit({});
					}
				});
			}
		}
	}

	// ------------------------------------------------------------------------------------------------->
	// native payments
	// ------------------------------------------------------------------------------------------------->

	// Native Payments (Apple/Google pay)

	appendApplePayButton(className: string) {
		const payButton = document.createElement('apple-pay-button');
		// Add any desired attributes or classes to the button
		payButton.setAttribute('buttonstyle', 'white-outline');
		payButton.setAttribute('type', 'plain');
		payButton.setAttribute('locale', 'en-US');
		payButton.addEventListener('click', this.initApplePaymentRequest.bind(this));
		$(document).ready(() => {
			$(className).append(payButton);
		});
	}

	initApplePaymentRequest() {
		const amount = this.ccinfo.amount;
		const sessionData = {
			amount,
			$storage: this.$storage,
		};
		this.showPaymentTypes = false;
		this.expayService.initApplePaymentRequest(sessionData)
			.then((token: any) => {
				if (!token) {
					this.showPaymentTypes = true;
					return;
				};
				const stringifiedToken = JSON.stringify(token);
				const cgAccount = this.$storage.paymentAccounts.find(account => account.paymentType == 'CreditGuard');
				if (!cgAccount) throw 'No valid payment account';

				// Needed to disctruct in order to zeroize the memory ref
				const freshAccount = {
					...cgAccount
				};

				freshAccount.providerInfo = {
					"applePay": {
						token: stringifiedToken
					},
				};
				this.setPaymentMethod(this.ccinfo, freshAccount);
				this.manualSubmit("Apple Pay");
			}).catch(err => {
				this.showPaymentTypes = true;
				console.error(err);
				this.expayService.handleNativePaymentError();
			});
	}

	initGooglePaymentRequest() {
		try {
			const amount = this.ccinfo.amount;
			const cgAccount = this.$storage.paymentAccounts.find(account => account.paymentType == 'CreditGuard');
			if (!cgAccount) throw 'No valid payment account';

			// Needed to disctruct in order to zeroize the memory ref
			const freshAccount = {
				...cgAccount
			};

			const sessionData = {
				amount,
				account: freshAccount,
				$storage: this.$storage
			};
			try {
				this.expayService.initGooglePayPayment(sessionData)
					.then(token => {
						freshAccount.providerInfo = {
							"googlePay": {
								token
							},
						};
						this.showPaymentTypes = false;
						this.setPaymentMethod(this.ccinfo, freshAccount);
						this.manualSubmit("Google Pay");
					}).catch(err => {
						this.showPaymentTypes = true;
						throw err;
					});
			} catch (err) {
				this.showPaymentTypes = true;
				console.error(err);
				this.expayService.handleNativePaymentError();
			}
		} catch (err) {
			this.showPaymentTypes = true;
			this.expayService.handleNativePaymentError();
		}
	}


}
